module.exports = __webpack_public_path__ + "af.svg?ddee87a8c4cdbc2a60b5d4ddc3a1549a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/af.svg
// module id = 960
// module chunks = 0